import React, { memo } from 'react'
import { LOADER_HANDLER_TYPES } from 'constants/index'
import { ContentLoaderIcon, HiveLoaderSmallIcon } from '../Icons/svg/index'

const spinnerSmClass =
  'inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent text-white align-[-0.125em]'

const spinnerClass =
  'inline-block h-8 w-8 animate-spin rounded-full border-[0.25em] border-current border-r-transparent text-white'

const Loader = ({ variant, ...props }) => {
  switch (variant) {
    case LOADER_HANDLER_TYPES.content:
      return (
        <div
          className='my-2 flex justify-center [&_svg]:h-[68px] [&_svg]:w-[68px]'
          style={props.style}
        >
          <ContentLoaderIcon />
        </div>
      )

    case LOADER_HANDLER_TYPES.liveWins:
      return (
        <div className='my-2 flex justify-center' style={props.style}>
          <HiveLoaderSmallIcon />
        </div>
      )
    case LOADER_HANDLER_TYPES.table:
      return <span className={spinnerSmClass} role='status' aria-hidden='true' />

    case LOADER_HANDLER_TYPES.submit:
      return <span className={spinnerSmClass} role='status' aria-hidden='true' />

    default:
      return <div className={spinnerClass} role='status' />
  }
}

export default memo(Loader)
